var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-overlay', {
    attrs: {
      "show": _vm.loading,
      "spinner-variant": "primary",
      "spinner-type": "grow"
    }
  }, [!_vm.getEvent ? _c('div', [_c('h1', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('event.not-found')))])]) : _c('div', [_c('event-header', {
    attrs: {
      "event": _vm.getEvent
    },
    on: {
      "show-new-item-modal": _vm.onShowNewItemModal
    }
  }), _c('event-flow', {
    ref: "eventFlowRef",
    attrs: {
      "event": _vm.getEvent
    }
  })], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }